/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import {IComponentOptions} from 'angular';
import ErrorService from '../../errors/service/ErrorService';

export class IbanInputComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        model: '=',
        name: '@',
        label: '@',
        clazz: '@',
        placeholder: '@',
        ngRequired: '<',
        bisherFs: '<?',
        bisherGs: '<?',
        bisherProperty: '@?'
    };
    template = require('./dv-iban-input.html');
    controller = DvIbanInputController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DvIbanInputController {

    static $inject: string[] = ['ErrorService'];

    model?: string;
    name: string;
    label: string;
    placeholder: string;
    clazz: string;
    ngRequired: boolean;
    bisherFs: any;
    bisherGs: any;
    bisherProperty: string;
    valueRequired: boolean = true; // default required

    constructor(private errorService: ErrorService) {
    }

    $onInit() {
        if (this.ngRequired !== undefined) {
            this.valueRequired = this.ngRequired;
        }
    }

    public showBisher(): boolean {
        return (this.bisherGs !== undefined && this.bisherFs !== undefined && this.bisherProperty !== undefined)
    }

    public handleBlur(event: any) {
        if (this.model) {
            this.model = this.model.toUpperCase();
            this.handleIbanChange();
        }
    }

    public validateIban(iban: string): boolean {
        let isIbanFormatValid: boolean = false;
        let isIbanModuloValid: boolean = false;

        this.errorService.clearAll();

        iban = iban.replace(/ /g, '').toUpperCase();

        // IBAN Validation
        const ibanRegex = /^CH\d{2}[0-9a-zA-Z]{17}$/;
        if (ibanRegex.test(iban)) {
            isIbanFormatValid = true;
        }
        // Es darf keine QR-IBAN sein
        // keine 3 an der dritten Stelle
        const qrIbanRegex = /^CH\d{2}3[0-9a-zA-Z]{16}$/;
        if (qrIbanRegex.test(iban)) {
            isIbanFormatValid = false;
        }

        isIbanModuloValid = this.checkIbanModulo(iban);

        return isIbanFormatValid && isIbanModuloValid;
    }

    private checkIbanModulo(iban: string) {
        // Modulo 97 Validation ohne BigInt
        const rearrangedIban = iban.slice(4) + iban.slice(0, 4);
        const numericIban = rearrangedIban.replace(/[A-Z]/g, (match) => (match.charCodeAt(0) - 55).toString());

        let remainder = numericIban;
        while (remainder.length > 2) {
            const block = remainder.slice(0, 9);
            remainder = (parseInt(block, 10) % 97).toString() + remainder.slice(block.length);
        }

        return parseInt(remainder, 10) % 97 === 1;

        // Modulo 97 validation mit BigInt
        // const rearrangedIban = iban.slice(4) + iban.slice(0, 4);
        // const numericIban = rearrangedIban.replace(/[A-Z]/g, (match) => (match.charCodeAt(0) - 55).toString());
        // const remainder = BigInt(numericIban) % 97;
        // return remainder === 1;
    }

    public handleIbanChange() {
        if (this.model && !this.validateIban(this.model)) {
            // Handle invalid IBAN
            this.errorService.addMesageAsError('ERROR_IBAN_FORMAT');

        }
    }
}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-iban-input/dv-iban-input.ts